export const toggleClientRoot = () => {
  let isClient = typeof window === "object";
  if (isClient) {
    // console.log("toggling client-root");
    
    // document.getElementById("root").innerHTML = document.getElementById(
    //   "client-root"
    // ).innerHTML;
    
    document.getElementById("client-root").style.display = "none";
    document.getElementById("root").style.display = "block";
  }
};
